import { ActionCreatorFactory } from 'typescript-fsa';

export function makeProductTourActions<ProductTourId>(
  actionCreator: ActionCreatorFactory,
) {
  const loadViewedProductTourDatabaseAC = actionCreator.async<void, ProductTourId[], Error>('LOAD_VIEWED_PRODUCT_TOUR_DATABASE');

  return {
    loadViewedProductTourDatabaseAC,
  };
}
